import React from "react";
import { formatGs } from "@/lib/format";
import { Users } from "lucide-react";

export const CashierSummary = ({ rows, selected, onSelect }) => (
  <div className="card-surface p-5 mb-6" data-testid="cashier-summary">
    <h3 className="font-head font-bold mb-4 flex items-center gap-2"><Users className="w-4 h-4 text-primary" /> Resumen por cajero</h3>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-[10px] tracking-widest text-muted-foreground border-b border-border">
          <th className="py-2 pr-3">CAJERO</th><th className="pr-3 text-right">VENTAS</th><th className="pr-3 text-right">TOTAL</th><th className="pr-3 text-right">EFECTIVO</th><th className="pr-3 text-right">POS</th><th className="pr-3 text-right">TRANSFER</th><th className="pr-3 text-right">CIERRES</th><th className="text-right">DIF. ARQUEO</th>
        </tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.cashier_id} onClick={() => onSelect(selected === r.cashier_id ? "" : r.cashier_id)} data-testid={`cashier-row-${r.cashier_id}`}
              className={`border-b border-border/50 cursor-pointer transition-colors ${selected === r.cashier_id ? "bg-primary/10" : "hover:bg-accent"}`}>
              <td className="py-2 pr-3 font-semibold">{r.name}</td>
              <td className="pr-3 text-right font-data">{r.num_sales}</td>
              <td className="pr-3 text-right font-data font-bold text-primary">{formatGs(r.total)}</td>
              <td className="pr-3 text-right font-data">{formatGs(r.by_method.efectivo)}</td>
              <td className="pr-3 text-right font-data">{formatGs(r.by_method.tarjeta)}</td>
              <td className="pr-3 text-right font-data">{formatGs(r.by_method.transferencia)}</td>
              <td className="pr-3 text-right font-data">{r.sessions}</td>
              <td className={`text-right font-data font-bold ${r.difference === 0 ? "text-emerald-500" : "text-red-500"}`}>{formatGs(r.difference)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">Sin ventas en el período</p>}
    </div>
    <p className="text-[11px] text-muted-foreground mt-2">Tocá un cajero para ver solo sus ventas en los reportes de abajo.</p>
  </div>
);
